// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"_e7405bc","linkIcon":"_f4ba524"};